import React, { Component } from "react";

interface Props extends JSX.ElementChildrenAttribute {
}

interface State {
  activeMenuItem: string,
  setActiveMenuItem: (activeMenuItem: string) => void,
}

export enum MedicamentViews {
  MEDICAMENTS_HOME = "/medicaments",
  MEDICAMENTS_SELECTION = "/medicaments/selection",
  MEDICAMENTS_DOSAGE = "/medicaments/dosage",
  VAT_GROUPS = "/medicaments/vat",
  ARTICLE_GROUPS = "/medicaments/article-groups",
  COVID_TEST_ANALYZERS = "/medicaments/covid-test-analyzers",
  STOCK_ORDERS = "/medicaments/stock-orders",
  STOCK_DATA = "/medicaments/stock-data"
}

export const MedicamentContext = React.createContext<State>({
  activeMenuItem: MedicamentViews.MEDICAMENTS_HOME,
  setActiveMenuItem: () => {
  },
});

export class MedicamentsProvider extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      activeMenuItem: MedicamentViews.MEDICAMENTS_HOME,
      setActiveMenuItem: this.setActiveMenuItem
    };
  }

  setActiveMenuItem = (activeMenuItem: string) => {
    this.setState({
      activeMenuItem: Object.values(MedicamentViews).includes(activeMenuItem) ?
          activeMenuItem :
          MedicamentViews.MEDICAMENTS_HOME,
    });
  };

  render() {
    return (
        <MedicamentContext.Provider value={this.state}>
          {this.props.children}
        </MedicamentContext.Provider>
    );
  }

}

export interface MedicamentConsumerRenderProps extends State {
}

export const withMedicamentContext = (Component: typeof React.Component | React.FunctionComponent<any>) => {
  return (props: any) => (
      <MedicamentContext.Consumer>
        {({...medicamentProps}: MedicamentConsumerRenderProps) => {
          return <Component {...props} {...medicamentProps} />
        }}
      </MedicamentContext.Consumer>
  );

};
